import React from 'react';
import { Table } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import { fitToPage, goToPage } from '@/hooks/paging';
import ToggleCardsButton from '@/components/cards/ToggleCardsButton';
import { presentationOptions } from '@/constants/states';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import ThemesFilters from './ThemesFilters';
import ThemesTableHeader from './ThemesTableHeader';
import ThemesTableRows from './ThemesTableRows';

const ThemesTable = ({
  category,
  currentPage,
  fetchData,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  themes,
  togglePresentation,
  total,
}) => {
  const { items, pageNumber } = fitToPage(themes, currentPage, pageSize);
  const ref = React.useRef(null);

  return (
    <div className="ReactTable" ref={ref}>
      <TableWrapper sticky celled className="aridhia-themes-table">
        <ThemesTableHeader readErrors={readErrors} readStatus={readStatus}>
          {togglePresentation && (readStatus !== states.PENDING) && (
            <ToggleCardsButton
              display={presentationOptions.TABLE}
              disabled={readStatus === states.PENDING}
              onClick={() => togglePresentation({ display: presentationOptions.CARDS })}
            />
          )}
          <ThemesFilters category={category} className="aridhia-table-filter" />
        </ThemesTableHeader>
        <Table.Body>
          <ThemesTableRows category={category} items={items} />
        </Table.Body>
      </TableWrapper>
      <NoRowsWithPagination
        currentPage={pageNumber}
        entity="theme"
        goToPage={({ page }) => goToPage(fetchData, { page }, ref)}
        icon="paint brush"
        items={items}
        pageCount={pageCount}
        readErrors={readErrors}
        readStatus={readStatus}
        total={total}
      />
    </div>
  );
};

export default ThemesTable;
